export default {
  供应商绩效管理: "供應商績效管理",
  删除成功: "刪除成功！",
  确认操作: "確認操作",
  "删除记录后不可恢复，你确定要执行此操作吗？":
    "刪除記錄後不可恢復，您確定要執行此操作嗎？",
  发起考核: "發起考核",
  考核维度: "考核維度",
  考核项: "考核項",
  "差 (25分)": "差 (25分)",
  "一般 (50分)": "一般 (50分)",
  "良好 (75分)": "良好 (75分)",
  "优秀 (100分)": "優秀 (100分)",
  创建成功: "創建成功",
  填写成功: "填寫成功！",
  "提交后表单将无法修改，您确定要提交吗？":
    "提交後表單將無法修改，您確定要提交嗎？",
  供应商绩效考核评估通过: "供應商績效考核評估通過",
  评估成功: "評估成功",
  请完成我的评价: "請完成我的評價",
  请选择考核人: "請選擇考核人",
  供应商绩效考核评分表: "供應商績效考核評分表",
  我的评分: "我的評分",
  评分邀请: "評分邀請",
  供应商基本信息: "供應商基本資訊",
  供应商id: "供應商id",
  供应商编号: "供應商編號",
  请输入供应商编号: "請輸入供應商編號",
  供应商名称: "供應商名稱",
  请输入供应商名称: "請輸入供應商名稱",
  采购金额: "採購金額",
  请选择采购金额: "請選擇採購金額",
  供应风险: "供應風險",
  请选择供应风险: "請選擇供應風險",
  供应商类别: "供應商類別",
  请选择供应商类别: "請選擇供應商類別",
  供应商改进和激励举措: "供應商改進和激勵舉措",
  请填写供应商改进和激励举措: "請填寫供應商改進和激勵舉措",
  供应商绩效评分: "供應商績效評分",
  评估人: "評估人",
  得分: "得分",
  "考核得分：": "考核得分：",
  "绩效级别：": "績效級別：",
  无需邀请其他考核人: "無需邀請其他考核人",
  "考核部门：": "考核部門：",
  "考核人：": "考核人：",
  供应商阶段: "供應商階段",
  已评估: "已評估",
  评估中: "評估中",
  考核得分: "考核得分",
  绩效级别: "績效級別",
  考核状态: "考核狀態",
  创建人: "創建人",
  考核发起人: "考核發起人",
  发起时间: "發起時間",
  分: "分",
};
